function setNotification(message, timeStart = 10) {
  let notifs = JSON.parse(localStorage.getItem("BTK-notifications"));
  if (!notifs) notifs = [];
  notifs.push({ text: message, id: Date.now(), timeStart: timeStart });
  localStorage.setItem("BTK-notifications", JSON.stringify(notifs));
}

export { setNotification };
